'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import BenefitsSection from './BenefitsSection';
import ROICalculator from './ROICalculator';
import ChatbotDemo from './ChatbotDemo';
import WorkflowSection from './WorkflowSection';
import TestimonialsSection from './TestimonialsSection';
import DemoRequestForm from './DemoRequestForm';

const CustomerSupportInteractive = () => {
  const [showDemoForm, setShowDemoForm] = useState(false);

  const handleDemoRequest = () => {
    const formSection = document.getElementById('demo-form');
    if (formSection) {
      formSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <HeroSection onDemoRequest={handleDemoRequest} />
      <BenefitsSection />
      <ROICalculator />
      <ChatbotDemo />
      <WorkflowSection />
      <TestimonialsSection />
      <div id="demo-form">
        <DemoRequestForm />
      </div>
    </>
  );
};

export default CustomerSupportInteractive;